<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")



  section.u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Afkar",
    "pageDesc":"Afkar contains some of the ideas and projects we are excited about and always exploring.",
    "mantra":"Projects we are |excited about."
  },
  "ar": {
    "pageTitle":"أفكار",
    "pageDesc":"توى أفكار على بعض المشروعات والموضوعات التي نتحمس على الدوام من أجل اكتشافها.",
    "mantra":"مشروعات |شغوفون بها."
  }
}
</i18n>
